import * as React from 'react';

function SvgPlusCircle(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM8 16A8 8 0 108 0a8 8 0 000 16z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 5a.75.75 0 00-1.5 0v6a.75.75 0 001.5 0V5z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.25a.75.75 0 000 1.5h6a.75.75 0 000-1.5H5z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgPlusCircle;
